import { Story } from '../../DocTypes';

export const DeselectWithRenderItemStory: Story = {
  title: 'De-select with renderItem',
  description: 'How to de-select an item in a selectable list with items that are custom rendered',

  reactWrapper: {
    jsx: `<Example />`,
    parentJSX: `Example = () => {
    const [selectedItem, setSelectedItem] = React.useState({ name: 'Jude Bellingham' })
    return (
      <div>
        <TagList
          keyField="name"
          selectable
          data={[
            { name: 'Harry Maguire' },
            { name: 'Luke Shaw' },
            { name: 'Mason Mount' },
            { name: 'Jude Bellingham' },
          ]}
          selectedItem={selectedItem}
          onListItemSelected={e => setSelectedItem(e.detail.item)}
          renderItem={item => <p>{item.name}</p>}
        />
        <TagButton
          text='De-select'
          onButtonClick={() => setSelectedItem(null)}
          buttonStyle={{marginTop: "10px"}}
        />
      </div>
    )
  }`,
  },
};
